package com.yendo.mx.ui.profile

import androidx.compose.foundation.background
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Block
import androidx.compose.material.icons.filled.Email
import androidx.compose.material.icons.filled.Logout
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.yendo.mx.models.UsuarioYendo
import com.yendo.mx.ui.theme.RosaYendo

@Composable
fun CuentaBloqueadaScreen(usuario: UsuarioYendo, onCerrarSesion: () -> Unit) {
    val isDark = isSystemInDarkTheme()
    val colorFondoGlobal = if (isDark) Color(0xFF121212) else Color(0xFFF8F8F8)
    val colorTextoPrincipal = if (isDark) Color.White else Color.Black
    val colorTextoSecundario = if (isDark) Color(0xFFAAAAAA) else Color.Gray
    val uriHandler = LocalUriHandler.current

    Box(
        modifier = Modifier.fillMaxSize().background(colorFondoGlobal).padding(24.dp),
        contentAlignment = Alignment.Center
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Icon(Icons.Default.Block, contentDescription = "Bloqueado", tint = Color.Red, modifier = Modifier.size(80.dp))
            Spacer(modifier = Modifier.height(24.dp))
            
            Text("Cuenta Suspendida", fontWeight = FontWeight.ExtraBold, fontSize = 26.sp, color = colorTextoPrincipal)
            Spacer(modifier = Modifier.height(16.dp))
            
            Text("Hola ${usuario.nombre}, el acceso a tu cuenta ha sido restringido por violaciones a los Términos y Condiciones.", textAlign = TextAlign.Center, color = colorTextoSecundario, fontSize = 14.sp)
            Spacer(modifier = Modifier.height(24.dp))

            Card(colors = CardDefaults.cardColors(containerColor = Color(0xFFFFEBEE)), shape = RoundedCornerShape(12.dp), modifier = Modifier.fillMaxWidth()) {
                Column(modifier = Modifier.padding(16.dp)) {
                    Text("Motivo de la suspensión:", fontWeight = FontWeight.Bold, color = Color.Red, fontSize = 12.sp)
                    Spacer(modifier = Modifier.height(4.dp))
                    Text(usuario.motivo_bloqueo.ifEmpty { "Revisión de seguridad." }, color = Color.Red, fontSize = 14.sp, fontWeight = FontWeight.Medium)
                }
            }

            Spacer(modifier = Modifier.height(40.dp))

            Button(
                onClick = {
                    // 🚀 FIX: Usamos la URL dinámica de Firebase
                    val urlAyuda = com.yendo.mx.repository.ConfigGlobalRepository.configCargada?.correo_soporte?.ifBlank { "https://www.yendo.com.mx/ayuda" } ?: "https://www.yendo.com.mx/ayuda"
                    try {
                        uriHandler.openUri(urlAyuda)
                    } catch (e: Exception) {
                        // Fallback
                    }
                },
                modifier = Modifier.fillMaxWidth().height(52.dp), colors = ButtonDefaults.buttonColors(containerColor = colorTextoPrincipal), shape = RoundedCornerShape(12.dp)
            ) {
                // Cambiamos el ícono a uno estándar de Material Icons Core
                Icon(Icons.Default.Email, null, tint = colorFondoGlobal, modifier = Modifier.size(20.dp))
                Spacer(Modifier.width(12.dp))
                Text("Contactar a Soporte", color = colorFondoGlobal, fontWeight = FontWeight.Bold, fontSize = 16.sp)
            }

            Spacer(modifier = Modifier.height(16.dp))

            OutlinedButton(
                onClick = onCerrarSesion,
                modifier = Modifier.fillMaxWidth().height(52.dp), shape = RoundedCornerShape(12.dp), border = androidx.compose.foundation.BorderStroke(1.dp, colorTextoSecundario)
            ) {
                Icon(Icons.Default.Logout, null, tint = colorTextoPrincipal, modifier = Modifier.size(20.dp))
                Spacer(Modifier.width(12.dp))
                Text("Cerrar sesión", color = colorTextoPrincipal, fontWeight = FontWeight.Bold, fontSize = 16.sp)
            }
        }
    }
}
